import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as VueGoogleMaps from 'vue2-google-maps'
import GmapCluster from 'vue2-google-maps/dist/components/cluster' // replace src with dist if you have Babel issues
import VueAnalytics from 'vue-analytics'
import VModal from 'vue-js-modal'
import VueCookies from 'vue-cookies'
import VueGtag from 'vue-gtag'

const GA_ID = process.env.VUE_APP_GA_ID

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCf-JyX_Q2cd2H4pvq1Lp7arYHuaDclKsU',
    libraries: 'places'
  }
})
Vue.component('GmapCluster', GmapCluster)

Vue.config.productionTip = false

Vue.use(VModal)

Vue.use(VueAnalytics, {
  id: GA_ID,
  router
})

Vue.use(VueGtag, {
  config: {
    id: process.env.VUE_APP_GTM_ID
  }
}, router)

Vue.use(VueCookies)
Vue.$cookies.config('1d')

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
